<template>

  <div class="d-flex align-center">
    <v-select
      :value="value"
      :items="categories"
      :label="$t('products.category.label')"
      @input="$emit('input', $event)"
    />

    <div class="icon" v-if="value">
      <v-btn text icon @click="clear()" v-if="clearable">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'product-categories-select',

    props: [ 'value', 'clearable' ],

    data () {
      return {
        categories: [
          { text: this.$t('products.category.material'), value: 'material' },
          { text: this.$t('products.category.work'), value: 'work' }
        ]
      }
    },

    methods: {
      clear () {
        this.$emit('input', null)
      }
    }
  }
</script>

<style scoped>

</style>
